module.exports = __webpack_public_path__ + "img/c-lifting.1ea20584.jpg";